import React, { useEffect, useMemo } from "react";

import { getCachedItem, setCachedItem } from "../../helpers";
import { useGetVendorList } from "../../hooks";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { StyledHubHookFormSelect } from "./styles";

export const VendorHookFormSelect = ({
  name = "vendorId",
  label = "Vendor",
  hideLabel = false,
  dispatch = () => {},
  required = true,
  disabled = false,
  includeName = false,
  groupByKey,
  location,
  ...rest
}) => {
  const cachedData = getCachedItem("vendors");
  const { data, isLoading, isSuccess } = useGetVendorList({
    location: location == 3 ? 1 : location,
    enabled: true,
  });
  const defaultOptions = cachedData || data || [];

  useEffect(() => {
    if (data && isSuccess) setCachedItem("vendors", data);
  }, [data]);

  const options = useMemo(() => defaultOptions || [], [defaultOptions]);

  const SelectComponent = groupByKey
    ? HubHookFormSelect
    : StyledHubHookFormSelect;
  return (
    <SelectComponent
      name={name}
      options={options}
      required={required}
      disabled={disabled || isLoading}
      {...(!hideLabel ? { label } : {})}
      groupByKey={groupByKey}
      {...rest}
    />
  );
};

export default VendorHookFormSelect;
